import React from "react";
import { CRMIcon, TIcon, TIconSizes } from "../CRMIcon/CRMIcon";

export type TTrafficLightStatus = "red" | "amber" | "green";

interface IIconTrafficLight {
    title?: string;
    iconName: TIcon;
    status: TTrafficLightStatus;
    size?: TIconSizes;
}

export class CRMIconTrafficLight extends React.Component<React.PropsWithChildren<IIconTrafficLight>> {
    public render (): JSX.Element {
        return (
            <div
                title={this.props.title}
                className={`
                    crm-icon-traffic-light 
                    crm-icon-traffic-light--colour-${this.props.status === "green" ? "highlights-positive-green-10"
                        : this.props.status === "amber" ? "highlights-pertinent-yellow-6"
                        : "highlights-instructional-brick-8"} 
                    crm-icon-traffic-light--${this.props.size || "medium"}
                `}
            >
                <CRMIcon
                    iconName={this.props.iconName}
                    colour="neutral-ink"
                    size={this.props.size}
                />
            </div>
        );
    }
}
